module.exports = "<div class=\"signInContainer\">\r\n    <router-outlet></router-outlet>\r\n</div>"